import { Injectable, signal } from '@angular/core';

/**
 * Mantém a última UF selecionada entre os painéis da Gestão Administrativa. Ao navegar de uma
 * tela para outra, a UF escolhida por último é carregada automaticamente (cada página lê este
 * valor na inicialização e grava aqui quando o usuário troca a UF).
 *
 * `null` representa "Brasil" (todas as UFs). Usuários restritos por token sempre forçam a sua UF.
 */
@Injectable({ providedIn: 'root' })
export class UfSelecaoGestaoService {
    private readonly _uf = signal<string | null>(null);

    /** UF selecionada por último (`null` = Brasil). */
    readonly uf = this._uf.asReadonly();

    definir(uf: string | null): void {
        this._uf.set(uf ?? null);
    }
}
